module.exports = __webpack_public_path__ + "img/app-smtt.80596634.webp";